import React from "react"
import {
    Box,
    componentStyles,
    useTheme,
} from "@mallardbay/lib-react-components"

import SEO from "~components/shared/seo"
import SearchTitle from "~components/pages/search/search-title"
import SearchFiltersButton from "~components/pages/search/search-filters-button"
import RecommendedSearches from "~components/pages/search/recommended-searches"
import Error from "~components/shared/error"
import COPY from "~config/copy-constants"
import SearchMap from "~components/pages/search/search-map"
import SearchResultsContainer from "~components/pages/search/search-results-container"
import { useSearch } from "~components/providers/search-provider"

export default function SearchContent() {
    const styles = useStyles()
    const { listings, error } = useSearch()

    if (error) return <Error errorMsg={error.message} />

    return (
        <>
            <SEO title={COPY.SEARCH} isNoIndex />
            <Box style={styles.root}>
                <Box style={styles.resultsWrapper}>
                    <Box style={styles.results}>
                        <Box style={styles.searchHeader}>
                            <SearchTitle />
                            <SearchFiltersButton />
                        </Box>
                        <SearchResultsContainer />
                    </Box>
                    <Box style={styles.suggestions}>
                        <RecommendedSearches />
                    </Box>
                </Box>
                <SearchMap listings={listings} />
            </Box>
        </>
    )
}

function useStyles() {
    const { colors } = useTheme()

    return componentStyles({
        root: {
            color: colors.contentPrimary,
            display: "flex",
            flexDirection: "row",
            minHeight: { base: "100vh", md: "calc(100vh - 72px)" },
            paddingTop: { base: "72px", md: 0 },
        },
        searchHeader: {
            display: "flex",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "24px",
        },
        resultsWrapper: {
            width: { base: "100%", md: "60%" },
            display: "flex",
            flexDirection: "column",
        },
        results: {
            flex: 1,
            padding: { base: "24px 24px 40px 24px", md: "40px 24px" },
        },
        suggestions: {
            padding: "40px",
        },
    })
}
